import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export type TermsAndConditionsLog = {
	UserName: string;
	Company_Name: string;
	Read_Date: string | null;
	NotificationVersion: string;
	TermsandConditionsMessage: string;
	PrivacyPolicyMessage: string;
	IsLogFromCompany: boolean;
	IsAcceptedTermsandConditions: boolean;
};

export const { thunk: getNotices, slice: getNoticesSlice } = getThunkAndSlice<object, TermsAndConditionsLog | null>({
	initialState: null,
	path: "/api/Account/api/Account/GetNotices",
	method: "get",
});
